import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-submit-confirmation",
  standalone: false,
  templateUrl: "./submit-confirmation.component.html",
  styleUrl: "./submit-confirmation.component.css",
})
export class SubmitConfirmationComponent {
  isconfirm: boolean = true;
  isSubmiting: boolean = false;
  countdown: number = 5;
  interval: any;
  @Output() dataChanged = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<SubmitConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  Submit() {
    this.isconfirm = false;
    this.isSubmiting = true;
    this.dataChanged.emit("submitted");
  }

  startCountdown() {
    this.interval = setInterval(() => {
      this.countdown--;

      if (this.countdown === 0) {
        clearInterval(this.interval);
        this.dialogRef.close(true);
      }
    }, 1000);
  }

  sendDataToParent() {}

  handleStatus(message: string) {
    if (message === "Completed") {
      this.isconfirm = false;
      this.isSubmiting = false;
      this.startCountdown();
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
